<template>
  <div class="main-info">
    <div>
      <h2 class="title" v-if=" this.getSkinInfos.info_title">
        {{ information.primary.title }}
      </h2>
    </div>
    <div class="meta-info-container">
      <div class="meta-info-row"  >
        <rating-stars  v-if=" this.getSkinInfos.action_rate" :mediaId="mediaId" :mediaType="mediaType"></rating-stars>

        <div class="meta-info" v-if="nbViews && this.getSkinInfos.info_views">
          <div class="info-icon" v-html="SVG.EYE_ICON_SVG" />
          <span>{{ nbViews }}</span>
        </div>
      </div>
      <div class="meta-info-row">
        <div class="meta-info"  v-if="this.getSkinInfos.info_date">
          <div class="info-icon" v-html="SVG.CALENDAR_ICON_SVG"/>
          <span>{{ formatDate(information.primary.date) }}</span>
        </div>
        <div class="meta-info" v-if="information.primary.duree && this.getSkinInfos.info_duration">
          <div class="info-icon" v-html="SVG.TIME_ICON_SVG"/>
          <span>{{ information.primary.duree }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import RatingStars from "./Sections/RatingStars/RatingStars.vue";
import {SVG} from '../../../../utils/const';
import { mapGetters } from "vuex";

export default defineComponent({
  name: "main-info",
  components: {
    RatingStars,
  },
  props: {
    information: {
      type: Object,
      required: true,
    },
    mediaId: {
      type: Number,
      required: true,
    },
    mediaType: {
      type: String,
    },
  },
  data() {
    return {
      nbViews: -1,
      SVG:SVG
    };
  },
  mounted() {
    this.nbViews = this.information.primary.nb_views;
  },
  methods: {
    formatDate(date) {
      var dt = new Date(date);
      var day = (dt.getDate() < 10 ? "0" : "") + dt.getDate();
      var month = (dt.getMonth() < 9 ? "0" : "") + (dt.getMonth() + 1);
      var year = dt.getFullYear();
      let newDate = day + "/" + month + "/" + year;
      return newDate;
    },
  },
    computed: {
    ...mapGetters(["getSkinInfos"]),

  },
});
</script>

<style></style>
